import { IFile } from '@sdk/contracts';

import { FileListWrapper, HeaderWrapper, TitleTextWrapper, Wrapper } from './FileAttachment.styles';
import { UploadFiles } from './UploadFiles';

import { UploadedFile } from '@/components/UploadedFile';

type Props = {
  value?: IFile[];
  onChange?: (files?: IFile[]) => void;
  title?: string;
};

export const FileAttachment: React.FC<Props> = ({ value = [], onChange, title }) => {
  const handleAdd = (newFile?: IFile[]) => {
    if (!newFile) return;
    onChange?.([...value, ...newFile]);
  };

  const handleRemove = (removeFile?: IFile) => {
    if (!removeFile) return;
    const updatedFiles = value.filter(file => file._id !== removeFile._id);
    onChange?.(updatedFiles);
  };

  return (
    <Wrapper>
      <HeaderWrapper>
        {title && <TitleTextWrapper>{title}</TitleTextWrapper>}
        <UploadFiles value={value} onChange={handleAdd} />
      </HeaderWrapper>
      <FileListWrapper>
        {value.map(file => (
          <UploadedFile
            key={file._id}
            file={file}
            setFile={handleRemove}
            maxWidth={'250px'}
            multiple
          />
        ))}
      </FileListWrapper>
    </Wrapper>
  );
};
